/* eslint-disable no-unused-vars */
import React from "react";
import { Navigate } from "react-router-dom";
import { BreadcrumbProvider } from "../context/BreadCrumbContext";
import { CreateEventProvider } from "../context/CreateEventContext";
import { EventProvider } from "../components/MPS/EventContext";
import { useAuth } from "../context/AuthContext";
import EODashboard from "../pages/Dashboard/EODashboard";
import DashboardContent from "../components/EO/DashboardContent";
import MarketplaceSellersContent from "../components/EO/MarketplaceSellersContent";
import SettingsContent from "../components/EO/SettingsContent";
import EventsContent from "../components/EO/EventsContent";
import CreateEventContent from "../components/EO/CreateEvent/CreateEventContent";
import StripeCallback from "../components/Stripe/StripeCallback";
import ViewEventDetails from "../components/EO/ViewEventDetails/ViewEventDetails";
import MarketplaceSellerDetails from "../components/EO/MarketplaceSellerDetails";
import ReceiptsList from "../components/Receipts/ReceiptsList";
import ReceiptView from "../components/Receipts/ReceiptView";
import VendorCRM from "../components/EO/VendorCRM/VendorCRM";
import AnalyticsDashboard from "../components/EO/Analytics/AnalyticsDashboard";
import TicketingDashboard from "../components/EO/TicketingDashboard";
import SupportContent from "../components/Support/SupportContent";
import TutorialVideos from "../components/Tutorials/TutorialVideos";
import NotificationHub from "../components/EO/NotificationHub";
import BoothsContent from "../components/EO/BoothsContent";
import EOReportsContent from "../components/EO/Reports/EOReportsContent";
import GrowthHub from "../components/EO/Growth/GrowthHub";

// Gate: only aaron@pebbletheapp.com can access /eo/growth
const GrowthGuard = ({ children }) => {
  const { user } = useAuth();
  if (user?.email !== "aaron@pebbletheapp.com") {
    return <Navigate to="/eo/dashboard" replace />;
  }
  return children;
};

const Providers = ({ children }) => (
  <BreadcrumbProvider>
    <EventProvider>
      <CreateEventProvider>
        <EODashboard>{children}</EODashboard>
      </CreateEventProvider>
    </EventProvider>
  </BreadcrumbProvider>
);

const routesConfig = [
  { path: "/eo/dashboard",      component: <DashboardContent /> },
  { path: "/stripe-callback",   useProviders: false },
  { path: "/eo/events",         component: <EventsContent /> },
  { path: "/eo/settings",       component: <SettingsContent /> },
  { path: "/eo/marketplace",    component: <MarketplaceSellersContent /> },
  { path: "/eo/booths",         component: <BoothsContent /> },
  { path: "/eo/create-event",   component: <CreateEventContent /> },
  { path: "/eo/events/:id",     component: <ViewEventDetails /> },
  { path: "/eo/marketplace/:id",component: <MarketplaceSellerDetails /> },
  { path: "/eo/receipts",       component: <ReceiptsList userType="EO" /> },
  { path: "/eo/receipts/:id",   component: <ReceiptView userType="EO" /> },
  { path: "/eo/vendor-crm",     component: <VendorCRM /> },
  { path: "/eo/analytics",      component: <AnalyticsDashboard /> },
  { path: "/eo/ticketing",      component: <TicketingDashboard /> },
  { path: "/eo/support",        component: <SupportContent /> },
  { path: "/eo/tutorials",      component: <TutorialVideos /> },
  { path: "/eo/notifications",  component: <NotificationHub /> },
  { path: "/eo/reports",        component: <EOReportsContent /> },
  {
    path: "/eo/growth",
    component: <GrowthGuard><GrowthHub /></GrowthGuard>
  },
];

export const eoRoutes = routesConfig.map(({ path, component, useProviders = true }) => ({
  path,
  element: useProviders ? <Providers>{component}</Providers> : component,
}));
